(function () {
  /**
   * @ngdoc module
   * @name app.core.main
   * @description where it all begins
   */
  angular.module('app.main', [
    'app.core.api',
    'binky.core.locale',
    'binky.core.lodash',
    'rcServices.browserSupported',
    'rcServices.rcUserRoles',
    'rcServices.storageAvailable',
    'ui.router',
  ]);
})();
